import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1446f040"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "email-items-header-container"
}
const _hoisted_2 = { class: "button-container" }
const _hoisted_3 = ["onMouseover"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onMouseover"]
const _hoisted_6 = ["onClick"]

import { computed, inject, ref, watch } from "vue";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import GridMenu from "@/components/ui/grid/grid-menu.vue";
import { ContextMenuItem } from "@/types/ui/menus/ContextMenuItem";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { TenantGuarantorItem } from "@/types/tenancies/TenantGuarantorItem";
import { Contacts } from "acquaint-api/models/Contacts";
import { DefaultContactType } from "acquaint-api/constants/DefaultContactType";
import FindContactModal from "@/components/find/contacts/find-contact-modal.vue";
import { ContactFindResult } from "@/types/find/contacts/ContactFindResult";
import ContactsPeekPopup from "@/components/contacts/contacts-peek-popup.vue";
import ContactModal from "@/components/contacts/record/contact-modal.vue";
import moment from "moment";
import { useContactHelper } from "@/utils/contacts/useContactHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'tenants-guarantors',
  props: {
  /**
   * The unique identifier for the tenant.
   * This is used for the tenancy tab in the contact record page.
   * @type {Number}
   * @default -1
   */
  tenantId: {
    type: Number,
    default: -1,
  },
  /**
   * A numeric value used to force updates or re-renders in the component.
   * @type {Number}
   * @required
   */
  forceUpdateValue: {
    type: Number,
    required: true,
  },
  /**
   * The height of grid.
   * @type {String}
   * @default 80vh
   */
  gridHeight: {
    type: String,
    default: "45vh",
  },
  /**
   * The boolean value to decide whether the fields are ready-only.
   * @type {boolean}
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
  /**
   * The boolean value to decide whether it's for edit.
   * @type {boolean}
   */
  editMode: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const { fetchContactById, updateContact } = useContactHelper();
const acquaintNextApiClient = inject(
  "AcquaintApiNextClient",
) as AcquaintApiNextClient;

const loading = ref(false);
const tenantGuarantorItems = ref<TenantGuarantorItem[]>([]);
const contextMenuId = ref("tenants-guarantors-grid-items");
const selectedRecord = ref<TenantGuarantorItem>();
const exportGrid = ref(false);
const displayFindContactModal = ref(false);
const displayNewContactModal = ref(false);
const defaultContactType = ref(-1);
const tenantIconId = ref(0);
const gaurantorIconId = ref("");
const peekContactId = ref(0);
const peekModalKey = ref(0);
const showPeek = ref(false);
const peekContactName = ref("");

const gridHeight = computed(() => {
  return `height: ${props.gridHeight};`;
});

const fetchTenantsGuarantors = async (tenantId: number) => {
  if (tenantId <= 0) return [];
  try {
    const items = await acquaintNextApiClient.httpGet<TenantGuarantorItem[]>(
      `/tenancies/guarantors/${tenantId}/tenant`,
    );
    return items;
  } catch (err) {
    return [];
  }
};

const refreshGridData = async () => {
  let items: TenantGuarantorItem[] = await fetchTenantsGuarantors(
    props.tenantId,
  );
  tenantGuarantorItems.value = [...items];
};

watch(
  () => props.forceUpdateValue,
  async () => {
    loading.value = true;
    selectedRecord.value = undefined;
    contextMenuId.value = `${contextMenuId.value}-${moment().unix()}`;
    tenantGuarantorItems.value = [];
    await refreshGridData();
    loading.value = false;
  },
  { immediate: true },
);

const menuItems = computed(() => {
  const menu: ContextMenuItem[] = [
    {
      key: "setGuarantor",
      text: "Set Guarantor",
      icon: "fas fa-user",
      disabled: !selectedRecord.value,
    },
    {
      key: "removeGuarantor",
      text: "Remove Guarantor",
      icon: "fas fa-trash",
      disabled: !(selectedRecord.value && selectedRecord.value.guarantorId > 0),
    },
    {
      key: "addLinkedTenant",
      text: "Add Linked Tenant",
      icon: "fas fa-user-group",
    },
    {
      key: "exportToExcel",
      text: "Export To Excel",
      icon: "fas fa-download",
    },
    {
      key: "refresh",
      text: "Refresh",
      icon: "fas fa-redo",
    },
  ];
  return menu;
});

const onMenuItemClicked = async (key: string) => {
  switch (key) {
    case "setGuarantor":
      defaultContactType.value = DefaultContactType.Guarantor;
      displayFindContactModal.value = true;
      break;
    case "removeGuarantor":
      await updateTenantGuarantor(0);
      await refreshGridData();
      break;
    case "addLinkedTenant":
      defaultContactType.value = DefaultContactType.Tenant;
      displayFindContactModal.value = true;
      break;
    case "exportToExcel":
      exportGrid.value = true;
      break;
    case "refresh": {
      await refreshGridData();
      break;
    }
    default:
      break;
  }
};

const onRowSelected = (e: TenantGuarantorItem | undefined) => {
  if (!e) {
    selectedRecord.value = undefined;
    return;
  }
  selectedRecord.value = e;
};

const handleContactSelected = async (selectedContact: ContactFindResult) => {
  if (!selectedContact) {
    return;
  }

  if (defaultContactType.value === DefaultContactType.Tenant) {
    const contact = await fetchContactById(selectedContact.id);
    if (contact) {
      contact.linkedTo = props.tenantId;
      await updateContact(contact);
    }
  } else if (defaultContactType.value === DefaultContactType.Guarantor) {
    await updateTenantGuarantor(selectedContact.id);
  }

  await refreshGridData();
};

const updateTenantGuarantor = async (guarantorId: number) => {
  if (selectedRecord.value) {
    const contact = await fetchContactById(selectedRecord.value?.tenantId);
    if (contact) {
      contact.guarantorID = guarantorId;
      await updateContact(contact);
    }
  }
};

const navigateToTenant = (contact: TenantGuarantorItem) => {
  if (contact.tenantId > 0) {
    peekModalKey.value++;
    showPeek.value = true;
    peekContactId.value = contact.tenantId;
    peekContactName.value = contact.tenantName;
  } else {
    defaultContactType.value = DefaultContactType.Tenant;
    displayFindContactModal.value = true;
  }
};

const displayTenantIcon = (id: number) => {
  tenantIconId.value = id;
};

const hideTenantIcon = () => {
  tenantIconId.value = 0;
};

const navigateToGaurantor = (contact: TenantGuarantorItem) => {
  if (contact.guarantorId > 0) {
    peekModalKey.value++;
    showPeek.value = true;
    peekContactId.value = contact.guarantorId;
    peekContactName.value = contact.guarantorName;
  }
};

const displayGaurantorIcon = (item: TenantGuarantorItem) => {
  if (item.guarantorId > 0) {
    gaurantorIconId.value = `${item.tenantId}-${item.guarantorId}`;
  }
};

const hideGaurantIcon = () => {
  gaurantorIconId.value = "";
};

const openNewContactModal = () => {
  displayNewContactModal.value = true;
};

const contactCreated = async (id: number) => {
  const newContact: Contacts | undefined = await fetchContactById(id);
  if (newContact) {
    const contact = await fetchContactById(newContact.id);
    if (defaultContactType.value === DefaultContactType.Tenant) {
      if (contact) {
        contact.linkedTo = props.tenantId;
        await updateContact(contact);
      }
    } else if (defaultContactType.value === DefaultContactType.Guarantor) {
      if (contact) {
        await updateTenantGuarantor(contact.id);
      }
    }

    await refreshGridData();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.tenantId > 0 && !__props.readOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(GridMenu, {
              "menu-items": menuItems.value,
              onItemClicked: onMenuItemClicked,
              "button-icon": "fas fa-bars",
              id: contextMenuId.value
            }, null, 8, ["menu-items", "id"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      style: _normalizeStyle(gridHeight.value)
    }, [
      _createVNode(GridBase, {
        "data-source": tenantGuarantorItems.value,
        "id-column-name": "tenantId",
        "column-auto-width": true,
        loading: loading.value,
        onAdaptiveRowSelection: onRowSelected,
        onRowSelected: onRowSelected,
        wordWrapEnabled: true,
        showSearchPanel: false,
        "run-export": exportGrid.value,
        "onUpdate:runExport": _cache[0] || (_cache[0] = ($event: any) => ((exportGrid).value = $event)),
        "custom-column-slots": ['tenantCell', 'guarantorCell']
      }, {
        columns: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "tenantId",
            caption: "Tenant Id",
            "hiding-priority": 1,
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "guarantorId",
            caption: "Guarantor Id",
            "hiding-priority": 1,
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "tenantName",
            caption: "Tenant",
            "hiding-priority": 2,
            "cell-template": "tenantCell"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "guarantorName",
            caption: "Guarantor",
            "hiding-priority": 2,
            "cell-template": "guarantorCell"
          })
        ]),
        tenantCellData: _withCtx(({ data }) => [
          _createElementVNode("div", {
            class: "property-contact-cell",
            onMouseover: ($event: any) => (displayTenantIcon(data.tenantId)),
            onMouseleave: hideTenantIcon
          }, [
            (tenantIconId.value == data.tenantId)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  onClick: ($event: any) => (navigateToTenant(data)),
                  class: _normalizeClass('fas fa-eye')
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(data.tenantName), 1)
          ], 40, _hoisted_3)
        ]),
        guarantorCellData: _withCtx(({ data }) => [
          _createElementVNode("div", {
            class: "property-contact-cell",
            onMouseover: ($event: any) => (displayGaurantorIcon(data)),
            onMouseleave: hideGaurantIcon
          }, [
            (
              gaurantorIconId.value &&
              gaurantorIconId.value === `${data.tenantId}-${data.guarantorId}`
            )
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  onClick: ($event: any) => (navigateToGaurantor(data)),
                  class: _normalizeClass('fas fa-eye')
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(data.guarantorName || " "), 1)
          ], 40, _hoisted_5)
        ]),
        _: 1
      }, 8, ["data-source", "loading", "run-export"])
    ], 4),
    _createVNode(FindContactModal, {
      modelValue: displayFindContactModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((displayFindContactModal).value = $event)),
      onContactSelected: handleContactSelected,
      typeToFind: defaultContactType.value,
      showNewContactButton: true,
      onOpenNewContactModal: openNewContactModal
    }, null, 8, ["modelValue", "typeToFind"]),
    (_openBlock(), _createBlock(ContactsPeekPopup, {
      key: peekModalKey.value,
      modelValue: showPeek.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showPeek).value = $event)),
      contactId: peekContactId.value,
      title: peekContactName.value
    }, null, 8, ["modelValue", "contactId", "title"])),
    _createVNode(ContactModal, {
      modelValue: displayNewContactModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((displayNewContactModal).value = $event)),
      onContactCreated: contactCreated,
      defaultType: defaultContactType.value
    }, null, 8, ["modelValue", "defaultType"])
  ], 64))
}
}

})